export enum WalletType {
  PeraWallet = "pera-wallet",
  WalletConnect = "wallet-connect",
  DeflyWallet = "defly-wallet",
  /** Signing will be handled by the parent application  */
  ParentSigner = "parent-signer"
}

export interface Wallet {
  id: WalletType;
  logo: string;
  logoAlt: string;
  title: string;
  description?: string;
}
